// /js/common/header.js
document.addEventListener('DOMContentLoaded', () => {
  const btn   = document.querySelector('[data-menu-toggle]');
  const panel = document.querySelector('[data-menu-panel]');
  if (!btn || !panel) return;

  // 二重初期化ガード
  if (btn.__menuBound) return;
  btn.__menuBound = true;

  const PC_QUERY = '(min-width: 1024px)';
  const HTML_OPEN_CLASS = 'is-menu-open';
  const BODY_FIXED_CLASS = 'is-fixed';

  // panelにIDが無ければ付与（aria-controlsと一致させる）
  if (!panel.id) panel.id = 'site-menu';

  // 初期ARIA（SPの初期状態＝閉じ）
  btn.setAttribute('aria-controls', panel.id);
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-label', 'メニューを開く');
  panel.setAttribute('aria-hidden', 'true');
  panel.setAttribute('inert', '');

  const mql = window.matchMedia(PC_QUERY);
  const state = { open: false }; // SP時のみ使用
  const isPC = () => mql.matches;

  const applyBodyLock = (lock) => {
    document.documentElement.classList.toggle(HTML_OPEN_CLASS, lock);
    document.body.classList.toggle(BODY_FIXED_CLASS, lock);
  };

  const reflectUI = () => {
    if (isPC()) {
      // PC：常時開く。ボタンは非表示、パネルは操作可能。
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'メニューを開く');
      panel.classList.add('is-open');
      panel.removeAttribute('aria-hidden');
      panel.removeAttribute('inert');
      applyBodyLock(false);
    } else {
      // SP：state.openに従う
      btn.hidden = false;
      btn.setAttribute('aria-expanded', String(state.open));
      btn.setAttribute('aria-label', state.open ? 'メニューを閉じる' : 'メニューを開く');
      panel.classList.toggle('is-open', state.open);
      panel.setAttribute('aria-hidden', String(!state.open));
      if (state.open) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
      applyBodyLock(state.open);
    }
  };

  const openMenu  = () => { if (!isPC()) { state.open = true;  reflectUI(); } };
  const closeMenu = () => { if (!isPC()) { state.open = false; reflectUI(); } };
  const toggleMenu = () => (state.open ? closeMenu() : openMenu());

  // クリックで開閉（SPのみ反応）
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (isPC()) return;
    toggleMenu();
  });

  // パネル内リンククリック時：SPでは確実に閉じる
  panel.addEventListener('click', (e) => {
    if (isPC()) return;
    const a = e.target.closest('a');
    if (!a) return;

    // 遷移やスクロール処理が始まる前に閉じるとフォーカスが飛ぶ場合があるので、最小遅延で閉じる
    setTimeout(closeMenu, 0);
  });

  // 外側クリックで閉じる（SPのみ）
  document.addEventListener('click', (e) => {
    if (isPC() || !state.open) return;
    if (!panel.contains(e.target) && !btn.contains(e.target)) closeMenu();
  });

  // Escで閉じる（SPのみ）
  document.addEventListener('keydown', (e) => {
    if (isPC()) return;
    if (e.key === 'Escape' && state.open) closeMenu();
  });

  // 画面幅の変化に追随（SP→PC/PC→SPいずれもクリーンな状態へ）
  const onMQChange = () => {
    state.open = false; // 切替時はいったん閉じ状態に寄せる
    reflectUI();
  };
  if (typeof mql.addEventListener === 'function') mql.addEventListener('change', onMQChange);
  else mql.addListener(onMQChange);

  // 初期反映 & iOS戻る対策（bfcache）
  reflectUI();
  window.addEventListener('pageshow', () => {
    // bfcache復帰時にスクロール固定が残らないよう再反映
    state.open = false;
    reflectUI();
  });
});
